import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import SegmentsOverview from "@/modules/segments/pages/SegmentsOverview.vue";
import SegmentConfigurationWrapper from "@/modules/segments/pages/SegmentConfigurationWrapper.vue";

export default new Route("segments", "/segments", RouterView, [
	new Route("segments.index", "", SegmentsOverview, [], {}),
	new Route(
		"segments.configuration",
		"configure/:resource_type?/:resource_uuid?",
		SegmentConfigurationWrapper,
		[],
		{}
	),
]);
